import React, { useState } from "react";
import Contacts from "@/pages/contacts";
// import Australiainvestorvisaimport from "@/pages/australiainvestorvisaimport";
const Australiaworkingvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/australiya.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          
        </div>
      </div>
      <div className="text-center text-3xl font-bold text-[#011473] drop-shadow-md mt-10 mx-auto md:ml-32 w-full md:w-3/4">
  Australia Professional Work Visa
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row ">
        {/* Left Section: Image */}

        <div className="mb-8 flex xl:w-1/2 w-3/4 justify-center lg:mb-0">
          <img
            src="/working.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="  space-y-4">
          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 mr-14 font-medium text-gray-700">
             <a className="text-black font-bold"> Regional Sponsored Visa (Subclass 187):</a> For skilled workers
              nominated by regional employers.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 mr-14 font-medium text-gray-700">
            <a className="text-black font-bold">Employer Nomination Visa (Subclass 186):</a> Permanent residency for
              employer-sponsored skilled workers.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 mr-14 font-medium text-gray-700">
            <a className="text-black font-bold">Skilled Regional Visa (Subclass 489):</a> Temporary visa for regional
              work and family sponsorship.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 mr-14 font-medium text-gray-700">
            <a className="text-black font-bold">Distinguished Talent Visa (Subclass 124):</a> For individuals with
              exceptional talent in their field.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 mr-14 font-medium text-gray-700">
            <a className="text-black font-bold">Business Talent Visa (Subclass 132):</a> Permanent visa for
              experienced business professionals.
            </span>
          </div>

          <div className="flex items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <span className="ml-3 mr-14 font-medium text-gray-700">
            <a className="text-black font-bold"> Business Innovation Visa (Subclass 188): </a>Temporary visa for
              entrepreneurs and investors.
            </span>
          </div>
        </div>
      </div>
      <div className="w-full items-center justify-center space-y-4 text-left md:text-center">
  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">  Short Stay Work Visa (Subclass 400):</a> For short-term specialized work projects.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Long Stay Work Visa (Subclass 401):</a> For cultural, social, or skill exchange roles.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> International Relations Visa (Subclass 403):</a> Work under Australia’s international agreements.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Seasonal Worker Visa (Subclass 416):</a> For participants in seasonal work programs.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Working Holiday Visa (Subclass 417):</a> For young travelers supplementing their funds.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Entertainment Visa (Subclass 420):</a> For work in Australia’s entertainment industry.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Skilled Work Visa (Subclass 457):</a> Employer-sponsored roles to address skill shortages.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">NZ Family Visa (Subclass 461):</a> For family members of New Zealand citizens in Australia.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Work and Holiday Visa (Subclass 462):</a> For young travelers from eligible countries.
    </span>
  </div>

  <div className="flex items-center justify-center md:justify-start">
    <div className="ml-0 md:ml-20 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Graduate Visa (Subclass 476):</a> For recent engineering graduates from recognized universities.
    </span>
  </div>
</div>

<div className="flex w-full flex-col items-center justify-center py-20">
  {isOpen && (
    <div className="mb-6 w-3/4 items-center justify-center rounded-md text-black bg-gray-100 p-4 text-lg shadow-md">
      <p>
        <br />
        <strong>Temporary Work Permit</strong>: An Australian working visa serves as a short-term permit, enabling individuals from around the globe to work in Australia.
        <br />
        <strong>Skill Shortages and Opportunities</strong>: Australia is home to numerous industries facing skill shortages, creating opportunities for highly skilled professionals from overseas to secure employment with Australian companies.
        <br />
        <strong>Top Global Destination</strong>: Renowned for its exceptional quality of life, robust Medicare system and world-class education, Australia is considered one of the most desirable countries to live and work in.
        <br />
      </p>
    </div>
  )}
  <button
    onClick={toggleAnswer}
    className="flex xl:w-1/2 w-2/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
  >
    Why Choose Australia for Work Opportunities?
    <svg
      className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M12 5v14M5 12l7 7 7-7"></path>
    </svg>
  </button>
</div>

      |
      <Contacts />
    </>
  );
};

export default Australiaworkingvisa;
